<template>
  <div class="page">
      <div class="d_c">
        <p>充值信息</p>
        <span class="rt-pos" @click="goBack()"></span>
      </div>
      <div class="d_nei">
        <p>
          <span>套餐名：</span><span class="p_c">{{propsParams.productName}}</span>
        </p>
        <p>
          <span>生效日期：</span><span class="p_c">立即生效</span>
        </p>
        <p>
          <span>流量：</span><span class="p_c">{{propsParams.flow}}</span>
        </p>
        <p>
          <span>数量：</span><span class="p_c"> {{propsParams.cardNumber}}</span>
        </p>
        <p>
          <span>单价：</span><span class="p_c"> {{'¥'+ propsParams.price}}</span>
        </p>
        <p>
          <span>总价：</span><span class="p_c"> {{'¥'+ propsParams.totalPrice}}</span>
        </p>
      </div>
      <div class="wenxin">
        <div class="p1">套餐说明：</div>
        <div class="p2">{{propsParams.description}}</div>
      </div>
      <form name="form"></form> 
      <div class="footer">
        <nut-button @click="pay()">立即订购</nut-button>
      </div>
  </div>
</template>

<script>

import { wx_center_productDetail } from "@/api/api.js"; //获取套餐列表
import wx from "weixin-js-sdk";
import { wx_Auth } from "@/api/api.js"; //获取微信信息
import { wx_batchOrderr } from "@/api/api.js"; //微信支付

export default {
  data() {
    return {
      propsParams:{},
      code:"",
      iccid:this.$route.query.iccid,
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    //获取微信信息
    handelWxConfig() {
      let params = {
        url: window.location.href,
        appId:sessionStorage.getItem("wechatId"),
        channel:localStorage.getItem("channel")
      };
      wx_Auth(params).then(res => {
        let dataObj = res.data.data;
        let getAppid = dataObj.appId;
        let getTimestamp = dataObj.timestamp;
        let getNonceStr = dataObj.nonceStr;
        let getSignature = dataObj.signature;
        wx.config({
          debug: false,
          appId: getAppid,
          timestamp: getTimestamp,
          nonceStr: getNonceStr,
          signature: getSignature,
          jsApiList: ["chooseWXPay"]
        });
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["chooseWXPay"],
            success: function(res) {}
          });
        });
      });
    },
    // 获取确认信息
    getPackage(){
      this.$toast.loading('加载中...',{ 
        duration:500,
        coverColor: "rgba(0,0,0,0.5)",
        closeOnClickOverlay: true,
        loadingRotate:true
      });
      let params ={
        productId:sessionStorage.getItem("id"),
        transId:sessionStorage.getItem("transId")
      }
      wx_center_productDetail(params).then(res => {
        if(res.data.code == 200){
          this.propsParams = res.data.data;
          this.propsParams.entryTime = "立即生效";
          this.propsParams.validTime = this.propsParams.validTime.substr(0,10);
        }
      })
    },
    // 充值
    pay(){
      let params ={
        productId:sessionStorage.getItem("id"),
        transId:sessionStorage.getItem("transId"),
        appId:sessionStorage.getItem("wechatId") || this.propsParams.appId,
        channel:localStorage.getItem("channel")
      }
      this.handelWxConfig();
      params.code = this.getUrlParam("code");
      let that = this;
      wx_batchOrderr(params).then(res=>{
        if (res.data.code == 200) {
            wx.chooseWXPay({
              timestamp: res.data.data.timeStamp,
              nonceStr: res.data.data.nonceStr, 
              package: res.data.data.packageValue, 
              signType: res.data.data.signType, 
              paySign: res.data.data.paySign, 
              success: function(res) {
                that.$router.push({
                  name: "userCenterPersona",
                });
              }
            })
        }else if(res.data.code == 415){
          that.$router.push({
            name: "userCenterPersona",
          });
        }else{
          this.$toast.fail(res.data.message);
        }
      })
      
    },
    // 获取url的code
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let url = window.location.href;
      let search = url.split("?")[1];
      if (search) {
        var r = search.substr(0).match(reg);
        if (r !== null) return unescape(r[2]);
        return null;
      } else {
        return null;
      }
    },
  },
  created() {

  },
  mounted(){
    window.document.title = "确认订单";
    this.getPackage();
  },
};
</script>
<style scoped lang="less">
  .page{
    .d_c{
      width: 100%;
      height: 180px;
      background: #F94040;
      z-index: 1;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
      p{
        font-size: 22px;
        text-align: center;
        color: #fff;
        padding-top: 35px;
      }
    }
    .d_nei{
      width: 95%;
      background: #fff;
      margin: 0 auto;
      z-index: 22;
      position: relative;
      top: -100px;
      padding: 5px;
      p{
        font-size: 14px;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        .p_c{
          color: #F94040;
        }
      }
    }
    .wenxin{
      margin-top: 25px;
      padding: 10px;
      .p1{
        color: #F94040;
        font-size: 14px;
      }
      .p2{
        margin-top: 5px;
        white-space: pre-wrap;
      }
    }
    .footer{
      background: #F8F8F8;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 23;
      button{
        border-radius: 10px;
        width: 52%;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
        border: 1px solid #F94040 !important;
      }
    }
    /deep/ .nut-textinput-clear{
      display: none;
    }
  }
</style>


